/**
 * Utility functions for AWS Cognito integration
 */

import { CognitoUser } from '../services/cognitoService';

/**
 * Get Cognito user ID as number (already a number)
 */
export const getUserIdAsNumber = (user: CognitoUser | null): number => {
  if (!user || user.id == null) {
    return 0;
  }
  const n = Number(user.id);
  return Number.isFinite(n) && n > 0 ? n : 0;
};

/**
 * Get user role with fallback
 */
export const getUserRole = (user: CognitoUser | null): string => {
  return user?.role || 'user';
};

/**
 * Get user business area with fallback
 */
export const getUserBusinessArea = (user: CognitoUser | null): string => {
  return user?.business_area || 'telecommunications';
};

/**
 * Check if user has a valid role
 */
export const hasValidRole = (user: CognitoUser | null): boolean => {
  return !!(user?.role && user.role.trim() !== '');
};
